import React from 'react'
/**
 * Landing screen for kiosk that shows a promotion image/video with "touch to start" button
 * Will show organization logo if no promo image/video is available
 * Overlays the restaurant select screen, disappears on press
 */
const KioskStartScreen = ({ defaultLogo, imageList, setVisible }) => {
	return <></>
}

export default KioskStartScreen
